import { useQuery } from '@tanstack/react-query';
import { getUserTimezone } from '../utils/dateUtils';

const downloadFile = (blob, filename) => {
  // For IE 10+
  if (navigator.msSaveBlob) {
    navigator.msSaveBlob(blob, `${filename}.csv`);
  } else {
    const link = document.createElement('a');
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `${filename}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  }
};

export const useExportStudentActivity = (apiHost, courseId, shouldFetch) => {
  const userTimezone = getUserTimezone();
  return useQuery({
    queryKey: ['activity-overview-export', courseId],
    queryFn: async () => {
      const response = await fetch(
        `${apiHost}/api/v1/dashboards/courses/${courseId}/activity-overview-widget/export`,
        {
          method: 'POST',
          credentials: 'include',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Pragma: 'no-cache',
          },
          body: JSON.stringify({ userTimezone }),
        }
      );
      if (!response.ok) {
        throw new Error('Failed to export student activity');
      }

      const blob = await response.blob();
      const filename = response.headers
        .get('Content-Disposition')
        .split('filename=')[1];
      downloadFile(blob, filename);
      return { success: true };
    },
    enabled: Boolean(shouldFetch && apiHost && courseId && userTimezone),
  });
};
